<template>
  <div id="app">
    <router-view />
    <H5TabBar v-if="!$route.meta.hideTabBar" />
    <div v-if="embeddedAuthExpired" class="auth-expired-mask" role="alert">
      <div class="auth-expired-card">
        <Icon type="ios-lock-outline" />
        <b>登录状态已失效</b>
        <span>{{ embeddedAuthMessage }}</span>
        <small>请返回小程序，然后重新进入本页面</small>
      </div>
    </div>
  </div>
</template>

<script>
import H5TabBar from './components/H5TabBar'

export default {
  name: 'App',
  components: { H5TabBar },
  data () {
    return {
      embeddedAuthExpired: false,
      embeddedAuthMessage: ''
    }
  },
  created () {
    window.addEventListener('wpc-h5-auth-expired', this.handleAuthExpired)
  },
  beforeDestroy () {
    window.removeEventListener('wpc-h5-auth-expired', this.handleAuthExpired)
  },
  methods: {
    handleAuthExpired (event) {
      const detail = event && event.detail ? event.detail : {}
      if (detail.embedded) {
        this.embeddedAuthExpired = true
        this.embeddedAuthMessage = detail.message || '登录凭证已过期'
        return
      }
      const redirect = this.$route.path === '/login' ? '' : this.$route.fullPath
      this.$router.replace({ path: '/login', query: redirect ? { redirect: redirect } : {} })
    }
  }
}
</script>

<style>
:root {
  --wpc-primary: #007de9;
  --wpc-primary-dark: #0068c7;
  --wpc-primary-soft: #eaf5ff;
  --wpc-bg: #f3f7fc;
  --wpc-card: #ffffff;
  --wpc-text: #183550;
  --wpc-text-secondary: #667085;
  --wpc-text-muted: #98a2b3;
  --wpc-line: #e9edf3;
  --wpc-radius: 16px;
}
html,
body,
#app {
  margin: 0;
  min-height: 100%;
  background: var(--wpc-bg);
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}
body {
  color: var(--wpc-text);
  -webkit-tap-highlight-color: transparent;
}
button,
input {
  font-family: inherit;
}
.ivu-btn-primary,
.ivu-btn-primary:hover,
.ivu-btn-primary:focus,
.ivu-btn-primary:active {
  background-color: var(--wpc-primary);
  border-color: var(--wpc-primary);
}
.ivu-checkbox-checked .ivu-checkbox-inner,
.ivu-checkbox-indeterminate .ivu-checkbox-inner {
  background-color: var(--wpc-primary);
  border-color: var(--wpc-primary);
}
.ivu-radio-checked .ivu-radio-inner {
  border-color: var(--wpc-primary);
}
.ivu-radio-inner::after {
  background-color: var(--wpc-primary);
}
.van-picker__confirm,
.van-picker__cancel {
  color: var(--wpc-primary);
}
.ivu-btn-large { height: 44px; border-radius: 8px; }
button:focus-visible { outline: 2px solid var(--wpc-primary); outline-offset: 3px; }
@keyframes wpc-reveal { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
.home-content, .report-card { animation: wpc-reveal .4s ease-out both; }
@media (prefers-reduced-motion: reduce) { .home-content, .report-card { animation: none; } }
.auth-expired-mask { position: fixed; z-index: 3000; inset: 0; padding: 24px; display: flex; align-items: center; justify-content: center; background: rgba(20, 33, 50, .48); }
.auth-expired-card { width: 100%; max-width: 330px; padding: 28px 22px; border-radius: 14px; box-sizing: border-box; display: flex; flex-direction: column; align-items: center; color: var(--wpc-text); background: #fff; text-align: center; }
.auth-expired-card > i { color: var(--wpc-primary); font-size: 42px; }
.auth-expired-card > b { margin-top: 8px; font-size: 17px; }
.auth-expired-card > span { margin-top: 10px; color: var(--wpc-text-secondary); font-size: 13px; line-height: 1.6; }
.auth-expired-card > small { margin-top: 4px; color: var(--wpc-text-muted); font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/App.vue